module.exports = __webpack_public_path__ + "img/newInv.c26c748f.svg";